import { render, staticRenderFns } from "./needKnow.vue?vue&type=template&id=621f8a40&scoped=true&"
import script from "./needKnow.vue?vue&type=script&lang=ts&"
export * from "./needKnow.vue?vue&type=script&lang=ts&"
import style0 from "./needKnow.vue?vue&type=style&index=0&id=621f8a40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621f8a40",
  null
  
)

export default component.exports